/* No-flash theme init. React Router v8 server-renders, so the active mode + palette must be
 * applied to <html> BEFORE first paint or the page flashes the default. Inject this tiny script
 * into the document <head> ahead of the stylesheet; it reconciles persisted choices synchronously.
 *
 *   // root.tsx (React Router v8)
 *   import { themeInitScript } from "@vlccrew/prism-next";
 *   ...
 *   <head>
 *     <script dangerouslySetInnerHTML={{ __html: themeInitScript }} />
 *   </head>
 *
 * Persistence keys match ThemeProvider: 'prism-theme' (light|dark), 'prism-semantics' (rose-pine|catppuccin).
 */
export const THEME_KEY = "prism-theme";
export const SEMANTICS_KEY = "prism-semantics";

export const themeInitScript = `(function(){try{var d=document.documentElement;var t=localStorage.getItem('${THEME_KEY}');if(t==='dark'||(!t&&window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches))d.classList.add('dark');if(localStorage.getItem('${SEMANTICS_KEY}')==='catppuccin')d.setAttribute('data-semantics','catppuccin');}catch(e){}})();`;
